import axios from "axios";

export const Apihistory = axios.create({
    baseURL: "https://historyv2.sitgps.com",
    headers: { 'Content-Type': 'application/json' },
});
Apihistory.defaults.headers.common['Appid'] = 'sitgps';